import { Grid, Box, makeStyles } from "@material-ui/core";

import Slide from "../../../../../../components/Slide";
import QHeader from "../../../../../../components/QHeader";

import Logo1 from "../../../../../../assets/_Chapters/CTeileSortiment/Handwerkzeuge/gesipa.png";
import Logo2 from "../../../../../../assets/_Chapters/CTeileSortiment/Handwerkzeuge/hazet.jpg";
import Logo3 from "../../../../../../assets/_Chapters/CTeileSortiment/Handwerkzeuge/kinpex.jpg";
import Logo4 from "../../../../../../assets/_Chapters/CTeileSortiment/Handwerkzeuge/stahlwille.jpg";
import Logo5 from "../../../../../../assets/_Chapters/CTeileSortiment/Handwerkzeuge/wera.png";
import Logo6 from "../../../../../../assets/_Chapters/CTeileSortiment/Handwerkzeuge/wiha.png";

import BackgroundImage from "../../../../../../assets/_Chapters/_Images/background/C-Teile-Sortiment/handwerkzeug.webp";

const useStyles = makeStyles({
  container: {
    "& .MuiGrid-grid-xs-4": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "& img": {
        width: "75%",
        margin: "auto",
        display: "block",
        maxWidth: "100%",
        maxHeight: "100px",
        width: "auto",
        maxWidth: "75%",
      },
    },
  },
});
export default function Handwerkszeug() {
  const classes = useStyles();
  return (
    <Slide
      background={{
        image: BackgroundImage,
        size: "55dvw",
        align: "left",
        position: "top left",
      }}
    >
      <Grid container className={classes.container}>
        <Grid item xs={12}>
          <QHeader title="Handwerkzeug" textAlign="center" />
        </Grid>
        <Grid container spacing={5}>
          <Grid item xs={4}>
            <img src={Logo1} alt="Logo" loading="lazy" />
          </Grid>
          <Grid item xs={4}>
            <img src={Logo2} alt="Logo" loading="lazy" />
          </Grid>
          <Grid item xs={4}>
            <img src={Logo3} alt="Logo" loading="lazy" />
          </Grid>
          <Grid item xs={4}>
            <img src={Logo4} alt="Logo" loading="lazy" />
          </Grid>
          <Grid item xs={4}>
            <img src={Logo5} alt="Logo" loading="lazy" />
          </Grid>
          <Grid item xs={4}>
            <img src={Logo6} alt="Logo" loading="lazy" />
          </Grid>
        </Grid>
      </Grid>
    </Slide>
  );
}
